import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * リンクカラム
 *【内容:content:string】
 *【選択候補:candidates:{label:string,value:string}[]】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-single-line-link-column',
  templateUrl: './single-line-link-column.html',
  styles: [`
    label.link {
      cursor: pointer;
    }
  `]
})
export class SingleLineLinkColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 選択候補
   */
  @Input() candidates:{label:string,value:string}[]

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  get selectedItem():{label:string,value:string} {
    return (this.candidates || []).find(
      each => each.value === this.content
    ) || {label:'', value:''}
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/single-line-link-column/single-line-link-column.component.ts